import ContactUs from '@pages/contact-us/contact-us';
export default ContactUs;
